import * as YourPensionSavings from './../actions/your-pension-savings.actions';
import { PensionSavings } from 'src/app/model/ngrx/pension-savings.model';

export type Actions = YourPensionSavings.YourPensionSavingsAction;

const initialState: PensionSavings = {
    fundValue: null,
    tfcAmt: '',
    tfcPct: '',
    extTfcAmt: '',
    extTfcPct: '',
    fullFundInd: '',
    drawdownInd: '',
    pensionProvider: '',
    address: {
        line1: '',
        line2: '',
        line3: '',
        line4: '',
        postcode: '',
        countryCode: ''
    },
    policyNo: '',
    isCeding: false,
    taxfreeSelected: '',
    optionCode: null,
    providerReference: null,
    productCode: ''
};

export function pensionSavingsReducer(state: PensionSavings[] = [initialState], action: Actions) {
    switch (action.type) {
        case YourPensionSavings.ADD_PENSION_SAVINGS:
            return [...state, action.payload];

        // Add this case:
        case YourPensionSavings.REMOVE_PENSION_SAVINGS:
            state = [];
            return state;

        default:
            return state;
    }
}
